import React from "react";
import { useNavigate } from "react-router-dom";
import {
  useStaggeredAnimation,
  generateAnimationDelays,
} from "utils/hooks/use-staggered-animation";

import { Button } from "app/components/ui/button";

const ANIMATION_DELAYS = generateAnimationDelays(8);

export const BestServiceHero = () => {
  const navigate = useNavigate();
  const { sectionRef, animatedStates } = useStaggeredAnimation({
    delays: ANIMATION_DELAYS,
    threshold: 0.1,
  });

  const [
    h1Animated,
    pAnimated,
    img1Animated,
    img2Animated,
    img3Animated,
    img4Animated,
    buttonAnimated,
    h3Animated,
  ] = animatedStates;

  return (
    <section
      ref={sectionRef}
      className="flex flex-col items-center pt-6 sm:pt-8 md:pt-10 lg:pt-[4.19rem] pb-16 sm:pb-20 md:pb-24 lg:pb-[7.44rem]"
    >
      <div className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 text-center mb-6 sm:mb-8 md:mb-10 lg:mb-[4.44rem]">
        <h1
          className={`text-[#1D1D1B] font-mobile text-[clamp(1.75rem,calc(3.25vw+1rem),4rem)] font-normal leading-tight md:leading-[1.3] lg:leading-[5.25rem] mb-0.5 transition-all duration-1000 ease-out ${
            h1Animated
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          Best Service for Platform Drivers
        </h1>
        <p
          className={`text-[#1D1D1B] text-base sm:text-[1.15rem] md:text-[1.22069rem] font-normal leading-5 sm:leading-6 md:leading-7 tracking-[-0.0375rem] transition-all duration-1000 ease-out ${
            pAnimated ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          Ensure you are always connected with the only triple 5G carrier
        </p>
      </div>
      <div className="flex items-center [@media(min-width:1422px)]:justify-center gap-4 md:gap-6 lg:gap-[1.625rem] w-full px-5 sm:px-6 md:px-7 lg:px-8 mb-16 sm:mb-20 md:mb-24 lg:mb-[7.44rem] overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
        <div
          className={`flex-shrink-0 w-[18.75rem] md:w-80 [@media(min-width:1594px)]:w-[22.6875rem] aspect-[0.695/1] rounded-[1.25rem] overflow-hidden group transition-all duration-1000 ease-out ${
            img1Animated
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <img
            src="/assets/best-service-image-1.webp"
            alt="Best Service 1"
            className="transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <div
          className={`flex-shrink-0 w-[18.75rem] md:w-80 [@media(min-width:1594px)]:w-[22.6875rem] aspect-[1.05/1] rounded-[1.25rem] overflow-hidden group transition-all duration-1000 ease-out ${
            img2Animated
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <img
            src="/assets/best-service-image-2.webp"
            alt="Best Service 2"
            className="transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <div
          className={`flex-shrink-0 w-[18.75rem] md:w-80 [@media(min-width:1594px)]:w-[22.6875rem] aspect-[0.812/1] rounded-[1.25rem] overflow-hidden group transition-all duration-1000 ease-out ${
            img3Animated
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <img
            src="/assets/best-service-image-3.webp"
            alt="Best Service 3"
            className="transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <div
          className={`flex-shrink-0 w-[18.75rem] md:w-80 [@media(min-width:1594px)]:w-[22.6875rem] aspect-[0.695/1] rounded-[1.25rem] overflow-hidden group transition-all duration-1000 ease-out ${
            img4Animated
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <img
            src="/assets/best-service-image-4.webp"
            alt="Best Service 4"
            className="transition-transform duration-300 group-hover:scale-105"
          />
        </div>
      </div>
      <div className="flex flex-col gap-5 justify-center items-center px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 sm:gap-7 md:gap-9 lg:gap-11">
        <div
          className={`transition-all duration-1000 ease-out ${
            buttonAnimated
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <Button
            type="button"
            variant="blackBtn"
            className="w-48 sm:w-56 lg:w-[17.625rem] h-12 sm:h-14 lg:h-[4.375rem] text-white text-sm sm:text-base md:text-lg lg:text-[1.27075rem] font-semibold md:leading-[1.575rem] lg:leading-[2.28738rem] hover:shadow-md"
            onClick={() => navigate("/network-plan")}
          >
            {/* Start for $1 -&gt; */}
            Get Started -&gt;
          </Button>
        </div>
        <h3
          className={`text-center font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[4rem] transition-all duration-1000 ease-out ${
            h3Animated
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          Best Coverage, Premium Security, Best VaLuE
        </h3>
      </div>
    </section>
  );
};
